import React from "react";

class CalcInput extends React.Component {
  handleChange(event) {
    this.props.onChange(event.target.value);
  }

  render() {
    return (
      <div className="field is-horizontal">
        <div className="field-label is-normal">
          <label className="label" dangerouslySetInnerHTML={{__html: this.props.input}} />
        </div>
        <div className="field-body">
          <div className="control">
            <input className="input" type="number" step="0.01" value={this.props.value} onChange={this.handleChange.bind(this)} />
          </div>
        </div>
      </div>
    );
  }
}

export default CalcInput;



// WEBPACK FOOTER //
// ./src/components/CalcInput/index.js